import React from 'react';
import * as s from './styled-skeleton';

const Skeleton = ({ width, height, circle, count = 1, gap }) => {
  if (count === 1) {
    return <s.Box width={width} height={height} circle={circle} />;
  }
  return (
    <s.Stack style={gap ? { gap } : undefined}>
      {Array.from({ length: count }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <s.Box key={`sk-${i}`} width={width} height={height} circle={circle} />
      ))}
    </s.Stack>
  );
};

export default Skeleton;
